import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUserPreferences } from "../api/USERS/users";
import { toast } from "react-toastify";

export function useUpdateUserPreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, preferences }) => updateUserPreferences(userId, preferences),
    onSuccess: (data, { userId }) => {
      // Le PUT retourne { result, message } sans data → on force un refetch du GET
      if (data?.data) {
        queryClient.setQueryData(["userPreferences", String(userId)], data);
      }
      queryClient.invalidateQueries({ queryKey: ["userPreferences", String(userId)] });
      queryClient.invalidateQueries({ queryKey: ["currentUser"] });
      toast.success("Préférences mises à jour avec succès", {
        autoClose: 3000,
        hideProgressBar: true,
        pauseOnHover: true,
      });
    },
    onError: (error) => {
      toast.error(error.message || "Erreur lors de la mise à jour des préférences", {
        autoClose: 3000,
        hideProgressBar: true,
        pauseOnHover: true,
      });
    },
  });
}
